import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';
import CardViewer from 'components/field/CardViewer';
import Modal from 'components/global/Modal';
import Radio from 'components/global/Radio';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import AddPaymentMethodModal from 'pages/Settings/Payment/ManageSubscription/AddPaymentMethod/AddPaymentMethodModal';

import { getClientCards } from 'stores/userSlice';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import * as S from './SelectCreditCard.styled';

const SelectCreditCard = NiceModal.create(({ selectedCard }) => {
	const modal = useModal();
	const dispatch = useDispatch();
	const [selectedCardId, setSelectedCardId] = useState(selectedCard);

	const user = useSelector((state) => state?.user);

	useEffect(() => {
		dispatch(getClientCards({}));
	}, []);

	const handleCloseModal = ({ creditCard }) => {
		modal.resolve({ creditCard });
		modal.remove();
	};

	const onSubmit = () => {
		handleCloseModal({ creditCard: user?.clientCards?.find?.((card) => card?.ID === selectedCardId) });
	};

	const handleAddCreditCard = async () => {
		await NiceModal.show(AddPaymentMethodModal);
	};

	return (
		<Modal maxWidth="x-small" fullwidth className="select-credit-card-modal" closeButton={true}>
			<ModalTitle>
				<Typography variant="p1">selectCreditCard</Typography>
			</ModalTitle>
			<ModalContent>
				<S.StyledForm borderless className="mb-3">
					{user.clientCards?.length > 0 ? (
						user.clientCards.map((card) => (
							<S.CardItem key={card.ID} onClick={() => setSelectedCardId(card.ID)}>
								<Radio className="mx-2" checked={selectedCardId === card.ID} readOnly />
								<CardViewer lastFour={card.cardLastFour} cardBrand={card.cardBrand} />
								{card.ID === selectedCard && (
									<S.Badge>
										<Typography variant="caption" fontWeight="500" color="var(--blue)">
											selected
										</Typography>
									</S.Badge>
								)}
							</S.CardItem>
						))
					) : (
						<Typography variant="p3">noCreditCardsAvailable</Typography>
					)}
				</S.StyledForm>
				<Button variant="transparent" label="addNewCreditCard" icon={faPlus} onClick={handleAddCreditCard} />
			</ModalContent>

			<ModalActions>
				<Button label="cancel" variant="borderless" onClick={handleCloseModal} />

				<Button label="confirm" onClick={onSubmit} />
			</ModalActions>
		</Modal>
	);
});

export default SelectCreditCard;
